const getMessage = (field) => `請選擇${field}`;
const validate = (value) => value !== '請選擇';

/** 自訂驗證三連動鄉鎮市是否輸入 */
export default {
  getMessage,
  validate,
};
